export default __webpack_public_path__ + "static/media/Delbick.83002dae.png";